export default __webpack_public_path__ + "static/media/satelites.32f1cb9e.jpg";